import { useCallback, useMemo } from "react";
import { SearchResult } from "../models/SearchResult";

export default function Pager(props: { result: SearchResult, isLoading: boolean, onPageClicked: (page: number) => any }) {
    const { meta } = props.result;

    const beforeButtons = useMemo(() => {
        const array: number[] = [];
        const lastNumber = Math.max(meta.current_page - 2, 2)
        for (let i = lastNumber; i <= meta.current_page - 1; i++) {
            array.push(i);
        }
        return array;
    }, [meta]);

    const afterButtons = useMemo(() => {
        const array: number[] = [];
        const lastNumber = Math.min(meta.current_page + 2, meta.last_page - 1)
        for (let i = meta.current_page + 1; i <= lastNumber; i++) {
            array.push(i);
        }
        return array;
    }, [meta]);

    return <>
        {
            meta.current_page > 1 ? <PrevPage currentPage={meta.current_page} onClick={props.onPageClicked} /> : null
        }

        <div className="wp-block-query-pagination-numbers wp-block-osica-osica-event-query-pagination-numbers" >
            {
                meta.current_page > 1 ? <PageNumberButton page={1} isCurrent={false} onClick={props.onPageClicked} /> : null
            }
            {
                (meta.current_page >= 5) ? <DotButton /> : null
            }

            {beforeButtons.map(index => <PageNumberButton page={index} onClick={props.onPageClicked} isCurrent={false} key={index} />)}

            <PageNumberButton page={meta.current_page} isCurrent={true} />

            {afterButtons.map(index => <PageNumberButton page={index} onClick={props.onPageClicked} isCurrent={false} key={index} />)}

            {
                (meta.last_page - meta.current_page >= 4) ? <DotButton /> : null
            }
            {
                meta.last_page > meta.current_page ? <PageNumberButton page={meta.last_page} isCurrent={false} onClick={props.onPageClicked} /> : null
            }
        </div>

        {
            meta.last_page > meta.current_page ? <NextPage currentPage={meta.current_page} onClick={props.onPageClicked} /> : null
        }
    </>;
}

function PrevPage(props: { currentPage: number, onClick?: (page: number) => any }) {
    const { currentPage, onClick } = props;
    const handleOnClick = useCallback(() => {
        if (onClick) {
            onClick(currentPage - 1);
        }
    }, [currentPage, onClick]);

    return <button className="btn btn-link wp-block-query-pagination-previous wp-block-osica-osica-event-query-pagination-previous"
        onClick={handleOnClick}>
        前のページ
    </button>
}

function NextPage(props: { currentPage: number, onClick?: (page: number) => any }) {
    const { currentPage, onClick } = props;
    const handleOnClick = useCallback(() => {
        if (onClick) {
            onClick(currentPage + 1);
        }
    }, [currentPage, onClick]);

    return <button
        className="btn btn-link wp-block-query-pagination-next wp-block-osica-osica-event-query-pagination-next"
        onClick={handleOnClick} >
        次のページ
    </button>
}

function PageNumberButton(props: { isCurrent: boolean, page: number, onClick?: (page: number) => any }) {

    const { page, onClick } = props;

    const handleOnClick = useCallback(() => {
        if (onClick) {
            onClick(page);
        }
    }, [page, onClick]);

    if (props.isCurrent) {
        return <span aria-current="page" className="page-numbers current" style={{ verticalAlign: 'middle' }}>{page}</span>
    } else {
        return <button className="btn btn-secondary page-numbers p-0 border-0" onClick={handleOnClick}>{page}</button>
    }
}

function DotButton() {
    return <span className="page-numbers dots" style={{ verticalAlign: 'middle' }}>…</span>;
}
